<template>
  <selector-frame v-if="selector.action" @close="close" :x="-180" :y="-210">
    <template slot="head">
      <div class="tags">
        <span v-for="(tag, i) in selector.tags" :key="i" class="tag">{{ tag }}</span>
      </div>
      <div class="info">
        <p>ドラッグ&ドロップでも音源を追加できます。</p>
      </div>
      <!-- <div class="edit">
        <div class="item">
          <div class="inputGroup">
            <div class="input"><input type="text" v-model="input" @mousedown.stop /></div>
          </div>
        </div>
      </div> -->
    </template>
    <div class="SoundSelector" @dragover.prevent @drop.prevent="onDrop">
      <div slot="body" class="sounds-list">
        <div class="sound">
          <p>- - - - - - - - - -</p>
          <div class="control">
            <faicon icon="stop-circle" class="icon" @click="select(null)" />
          </div>
        </div>
        <div class="sound" v-for="(sound, i) in sounds" :key="sound.key">
          <p class="text m-ellipsis" v-show="!isCurrent(sound.key)" @click="current(sound.key, sound.name)">
            <faicon icon="pen" class="icon" />
            {{sound.name}}
          </p>
          <p class="input" v-show="isCurrent(sound.key)">
            <input type="text" :ref="sound.key" v-model="input" @mousedown.stop>
            <faicon v-if="isCurrent(sound.key)" icon="check-circle" class="icon" @click="save(sound.key)" />
          </p>
          <p class="loop" v-if="!isCurrent(sound.key)" v-text="sound.loop ? 'loop:yes' : 'loop:no'" @click="setLoop(sound.key, !sound.loop)"></p>
          <div class="control">
            <faicon  v-if="isCurrent(sound.key)" icon="arrow-up" class="icon" @click="index(sound.key, sounds[i - 1])"  />
            <faicon  v-if="isCurrent(sound.key)" icon="arrow-down" class="icon" @click="index(sound.key, sounds[i + 1])" />
          </div>
          <p class="volumes"><span>vol:</span><input type="number" :value="sound.volume" @change="(e) => setVolume(e, sound.key)" min="0" max="100"></p>
          <!-- <p class="volumes" v-if="!isCurrent(sound.key)" @mousedown.stop>
            <span class="volume" :class="{ fill: i * 5 < sound.volume }" v-for="i in 20" :key="i" @click="setVolume(sound.key, i * 5)"></span>
          </p> -->
          <div class="control">
            <faicon v-if="isCurrent(sound.key)" icon="trash" class="icon" @click="remove(sound.key)" />
            <faicon icon="play-circle" class="icon" @click="select(sound.key)" />
          </div>
        </div>
        <div class="select">
          <label class="image no-image">
            <faicon class="icon" icon="plus" />
            <input type="file" @change="onChange" :style="{ display: 'none' }" />
          </label>
        </div>
      </div>
    </div>
  </selector-frame>
</template>

<script>
import selectorFrame from '../frames/selector'
import bar from '../common/bar'

export default {
  components: { 'selector-frame': selectorFrame, bar },
  data() {
    return {
      currentKey: null,
      input: ''
    }
  },
  computed: {
    sounds() {
      return this.$store.getters['sounds/tagged'](this.selector.tags)
    },
    selector() {
      return this.$store.getters['selectors/sound']
    }
  },
  methods: {
    onChange(e) {
      const { files } = e.target
      const { tags } = this.selector
      if (files.length > 0) this.$store.dispatch('sounds/upload', {
        name: files[0].name,
        file: files[0],
        tags,
        index: 0
      }).then(doc => {
        this.$emit('uploaded', doc.id)
      }).catch(() => {
        // console.error(err)
        alert('ファイルのアップロードに失敗しました。')
      })
      e.target.value = null
    },
    onDrop(e) {
      const files = e.dataTransfer.files
      const { tags } = this.selector
      for (var i=0; i<files.length; i++) {
        if (files.length > 0) this.$store.dispatch('sounds/upload', {
          name: files[i].name,
          file: files[i],
          tags,
          index: i
        }).then(doc => {
          this.$emit('select', doc.id)
        }).catch(() => {
          // console.error(err)
          alert('ファイルのアップロードに失敗しました。')
        })
      }
    },
    save() {
      const { currentKey, input } = this.$data
      if (!currentKey || !input) return
      this.$store.dispatch('sounds/setName', { key: currentKey, name: input })
      this.current(null)
    },
    current(key, name = '') {
      // this.$store.commit('sounds/$checkout', key)
      this.$data.currentKey = key
      this.$data.input = name
      this.$nextTick(() => {
        const inputs = this.$refs[key]
        if (inputs && inputs[0]) inputs[0].focus()
      })
    },
    isCurrent(key) {
      return this.$data.currentKey === key
    },
    select(key) {
      this.$store.dispatch(this.selector.action, { value: key, ...this.selector.context })
    },
    setVolume(e, key) {
      const value = e.currentTarget.value
      const volume = Math.max(Math.min(~~value, 100), 0)
      e.currentTarget.value = volume
      this.$store.dispatch('sounds/$update', { key, data: { volume } })
    },
    setLoop(key, loop) {
      this.$store.dispatch('sounds/$update', { key, data: { loop } })
    },
    index(key, target) {
      const index = this.$store.getters['sounds/$sorted'].indexOf(target)
      this.$store.dispatch('sounds/$index', { key, index})
    },
    remove(key) {
      this.$store.dispatch('sounds/remove', key)
    },
    close() {
      this.$store.commit('selectors/closeSound')
    }
  }
}
</script>

<style scoped>
.SoundSelector {
  width: 430px;
  height: 420px;
}
.tags {
  display: flex;
}
.tag {
  border: 1px solid #222;
  padding: 5px 7px;
  border-radius: 15px;
  background: rgba(0, 0, 0, 0.2);
  color: #ccc;
  font-size: 10px;
}
.info {
  margin-left: 5px;
  font-size: 10px;
  color: #888;
}
.sound-list {
}
.control {
  margin-right: 10px;
  display: flex;
}
.control .icon {
  margin-left: 5px;
  vertical-align: middle;
  padding: 4px 1px;
  cursor: pointer;
}
.control .icon:hover {
  color: #222;
}
.sound {
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sound + .sound {
  border-top: 1px solid #222;
}
.select label {
  box-sizing: border-box;
  padding: 5px;
  display: block;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  font-size: 10px;
  color: #ccc;
  text-align: center;
  cursor: pointer;
}
.text {
  margin-right: 5px;
  font-size: 12px;
  flex: 1;
}
.text .icon {
  position: relative;
  top: -2px;
  margin-left: 5px;
  color: #222;
  width: 10px;
  height: 10px;
}
.input {
  position: relative;
}
.input .icon {
  position: absolute;
  right: 7px;
  top: 7px;
  cursor: pointer;
}
.input .icon:hover {
  color: #444;
}
.input input[type=text] {
  padding-right: 22px;
  width: 245px;
}
.volume {
  border-left: 1px solid #888;
  width: 1px;
  height: 10px;
  display: inline-block;
}
.volume.fill {
  border-left: 1px solid #222;
}
.volumes {
  display: flex;
  align-items: center;
}
.volumes span {
  margin-right: 5px;
  font-size: 10px;
  color: #888;
}
.volumes input[type=number] {
  width: 5em;
}
.loop {
  margin: 0 5px;
  font-size: 10px;
  cursor: pointer;
}
</style>
